import { useParams } from 'react-router-dom'
import SeoHead from '../components/SeoHead'
import UseCaseArticle from '../views/usecases/UseCaseArticle'
import { getLocalizedUseCase, getUseCaseBySlug } from '../content/useCases'
import { useLanguage } from '../i18n/LanguageContext'

const UseCaseArticlePage = () => {
  const { slug } = useParams<{ slug: string }>()
  const { language, t } = useLanguage()
  const entry = slug ? getUseCaseBySlug(slug) : undefined

  const localizedEntry = entry ? getLocalizedUseCase(entry, language) : undefined
  const metaTitle = localizedEntry?.metaTitle || t('seo.useCaseFallbackTitle')
  const metaDescription = localizedEntry?.metaDescription || t('seo.useCaseFallbackDescription')
  const path = slug ? `/solutions/${slug}` : '/solutions'

  return (
    <>
      <SeoHead
        title={metaTitle}
        description={metaDescription}
        path={path}
        keywords={localizedEntry?.keywords}
        structuredData={localizedEntry ? [
          {
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: localizedEntry.title,
            description: metaDescription,
            author: {
              '@type': 'Organization',
              name: 'SheetMate'
            }
          },
          {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: t('navigation.solutions'),
                item: 'https://sheetmate-452111.web.app/solutions'
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: localizedEntry.title,
                item: `https://sheetmate-452111.web.app${path}`
              }
            ]
          }
        ] : undefined}
        noIndex={!localizedEntry}
      />
      <UseCaseArticle entry={entry} />
    </>
  )
}

export default UseCaseArticlePage
